import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { CloseDialogIcon } from "assets/styles/icons";
import { useSelector } from "react-redux";
import {
  AppPrimaryButton,
  AppSecondaryButton,
} from "shared/components/AppComponents";
import { handleNoOfPropertiesChange } from "../accordion/AccordionReviewDetails";
import { handleSaveProperty } from "../../security/LiabilitiesLegalTies";
import { useProgress } from "context/ProgressProvider";

const DialogDeleteProperty = ({
  showDialogDelete,
  setShowDialogDelete,
  handleContinue,
  callback,
  isBroker,
}: any) => {
  const { currentProfile } = useProgress();

  const handleDeleteProperties = (formValues, callback) => {
    const resultProperties = handleNoOfPropertiesChange(
      formValues.noOfProperties,
      currentProfile,
      formValues,
    );
    handleSaveProperty(
      true,
      {
        isPropertyOwned: true,
        noOfProperties: formValues.noOfProperties,
        properties: resultProperties.fullProperties?.map(
          ({ isAllDataFilled, _id, ...rest }) => rest,
        ),
      },
      currentProfile.loadId,
      (res) => {
        if (res) {
          callback(true, resultProperties);
          //   handleSuccessMultiProperties(resultProperties);
        } else {
          callback(false, "");
          //   formik.setSubmitting(false);
        }
      },
    );
  };

  return (
    <Dialog open={showDialogDelete !== false} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h2">Confirmation</Typography>
          <IconButton
            onClick={() => {
              setShowDialogDelete(false);
            }}
          >
            <CloseDialogIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" className="f15">
          {isBroker ? (
            <>
              Are you sure you want to delete? Continuing this action will
              permanently remove your customer last remaining property.
            </>
          ) : (
            <>
              Are you sure you want to delete? Continuing this action will
              permanently remove your last remaining property.
            </>
          )}
        </Typography>
      </DialogContent>

      <DialogActions className="p-6">
        <AppSecondaryButton
          title="Cancel"
          className="btn-small"
          onClick={() => {
            setShowDialogDelete(false);
          }}
        />
        <AppPrimaryButton
          title="Continue"
          className="btn-small"
          loadingText="DELETING"
          onClick={() => handleDeleteProperties(showDialogDelete, callback)}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogDeleteProperty;
